function resize() {
	window.resize = function() {
		// SRC: https://stackoverflow.com/a/1818513
		const resizeEvent = window.document.createEvent('UIEvents');
		resizeEvent.initUIEvent('resize', true, false, window, 0);
		window.dispatchEvent(resizeEvent);
	};
}
resize();
